class pageTop {
  constructor(el, opt) {
    this.el = el;
    if (document.querySelector('.js-top-about')) {
      this.aboutAnimation();
    }
    if (document.querySelector('.js-scroll-bar')) {
      this.scrollBarAnimation();
    }
    if (document.querySelector('.js-top-workplace-swiper')) {
      this.workplaceSwiper();
    }
    if (document.querySelector('.js-top-staff-swiper')) {
      this.staffSwiper();
    }
  }
  aboutAnimation() {
    const animationWrap = document.querySelector('.js-top-about');
    const logoText = animationWrap.querySelector('.js-top-about__logo-text');
    const map = animationWrap.querySelector('.js-top-about__map');
    const ripple = animationWrap.querySelectorAll('.js-top-about__ripple > div');
    const logo = animationWrap.querySelector('.js-top-about__logo');
    const textWrap = animationWrap.querySelector('.js-top-about__text-wrap');
    const mm = gsap.matchMedia();
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: animationWrap,
        start: "top center",
        end: "bottom top",
        scrub: false
      },
    });
    mm.add('(max-width:767px)', () => {
      tl
        .from(textWrap, {
          opacity: 0,
          duration: 1
        })
        .to(logoText, {
          opacity: 1,
          left: '50%',
          duration: 2
        }, '<=')
        .to(map, {
          opacity: 1,
          y: 0,
          duration: 1
        }, '-=1.5')
        .to(logo, {
          opacity: 1,
          y: '50%',
          ease: "bounce.out",
          duration: 3
        }, '-=1')
        .from(ripple, {
          opacity: 0,
          width: 0,
          duration: 7,
          stagger: {
            each: 0.2
          },
          ease: "power4.out",
        }, '-=2')
    })
    mm.add('(min-width:768px)', () => {
      tl
        .to(logoText, {
          opacity: 1,
          left: '50%',
          duration: 2
        })
        .to(map, {
          opacity: 1,
          y: 0,
          duration: 1
        }, '-=1.5')
        .to(logo, {
          opacity: 1,
          y: '50%',
          ease: "bounce.out",
          duration: 3
        }, '-=1')
        .from(textWrap, {
          opacity: 0,
          duration: 1
        }, '-=2')
        .from(ripple, {
          opacity: 0,
          width: 0,
          duration: 7,
          stagger: {
            each: 0.2
          },
          ease: "power4.out",
        }, '-=2')
    })
  }
  scrollBarAnimation() {
    const barItems = document.querySelectorAll('.js-scroll-bar > img');
    gsap.to(barItems, {
      opacity: 1,
      stagger: 0.5,
      duration: 0.5,
      repeat: -1,
      repeatDelay: 0.8,
    })
  }
  workplaceSwiper() {
    const swiperEle = document.querySelector('.js-top-workplace-swiper');
    new Swiper(swiperEle, {
      loop: true,
      speed: 10000,
      slidesPerView: 'auto',
      autoplay: {
        delay: 0
      }
    })
  }
  staffSwiper() {
    const mm = gsap.matchMedia();
    mm.add('(max-width:768px)', () => {
      new Swiper('.js-top-staff-swiper', {
        spaceBetween: 40,
        slidesPerView: 1.3,
        loop: true,
        autoplay: {
          delay: 4000
        }
      })
    })
  }
}